export interface IFateState {
  activePurchase: any | null,
  avatarSelected: any | null,
  hasFetched: boolean,
  isDialogOpen: boolean,
  isExceptionalFriend: boolean,
  isFetching: boolean,
  isPurchasing: boolean,
  message: string | null,
  purchaseComplete: boolean,
  data: FateData,
}

export type FateData = {
  currentFate: number,
  fateCards: IFateCard[],
  premiumSubPurchaseCard?: IFateCard,
};

export interface IFateCard {
  id: number,
  image: string,
  name: string,
  description: string,
  action: string,
  price: number,
  type: string,
  canAfford: boolean,
  border: string,
}

export enum ExceptionalFriendWizardStep {
  Loading,
  Blurb,
  Payment,
  Success,
  Error
}

